import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "form"]

  connect() {
    this.originalText = this.textTarget.textContent
    this.textTarget.textContent = ""
    this.typeOut(0)
  }

  typeOut(index) {
    if (index < this.originalText.length) {
      this.textTarget.textContent += this.originalText[index]
      setTimeout(() => this.typeOut(index + 1), 50)
    } else {
      this.formTarget.classList.add("inline-block")
      this.formTarget.classList.remove("hidden")
    }
  }
}
